import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Skeleton,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import defaultImage from "../../assets/svg/defultImage.svg";
import axios from "axios";
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import { useNavigate } from "react-router";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./Engineer.css";
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined, Search } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";

const OrdersExecuting = () => {
  const token = sessionStorage.getItem("token");
  const [orders, setOrders] = useState([]);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [filterDate, setFilterDate] = useState(null);
  const [selectedDays, setSelectedDays] = useState("");
  const [daysDropdownOpen, setDaysDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const getOrders = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${newHost}stuff/get-order-products`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            ...(filterDate && { date: filterDate }),
            ...(selectedDays && { days: selectedDays }),
          },
        },
      );
      const orders = response.data.data?.data;

      setOrders(orders);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrders();
  }, [filterDate, selectedDays]);

  const navigte = useNavigate();

  const navigateToCheckItems = (order) => {
    // navigte(`/ordersExecution/checkItems/${order.id}`, { state: { order } });
    navigte(`/ordersExecution/executeByService/${order.id}`);
  };

  // ===== Skeleton card matching the Accordion shape =====
  const renderOrderSkeleton = (key) => (
    <div
      key={key}
      className="shadow-sm"
      style={{
        backgroundColor: "#F9F9F9",
        margin: "16px 0",
        padding: "16px",
        borderRadius: "8px",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <div className="d-flex gap-2 align-items-center">
          <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" width={140} height={32} />
        </div>
        <div style={{ flexGrow: 1 }} />
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>
    </div>
  );

  return (
    <>
      <div className="m-4 min-vh-100" dir="rtl">
        <div className="d-flex align-items-center gap-4">
          <div className="date-remove-space" >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker'"]}>
                <DatePicker
                  sx={{ width: "100%" }}
                  className="m-0"
                  format="YYYY,MM,DD"
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "اختار تاريخ الطلب",
                    },
                    field: {
                      clearable: true,
                      onClear: () => setFilterDate(""),
                    },
                  }}
                  value={filterDate ? dayjs(filterDate) : null}
                  onChange={(date) =>
                    setFilterDate(date ? date.format("YYYY-MM-DD") : "")
                  }
                />
              </DemoContainer>
            </LocalizationProvider>


          </div>
          <div className="">
    <div className="position-relative">
            <button
              type="button"
              onClick={() => setDaysDropdownOpen((prev) => !prev)}
              className="form-control rounded-3 border-light-subtle shadow-sm d-flex align-items-center justify-content-between bg-white"
              style={{ width: "200px", cursor: "pointer" }}
            >
              <span
                className={selectedDays ? " fw-semibold text-dark" : "text-muted"}
              >
                {selectedDays
                  ? `عدد الأيام: ${selectedDays}`
                  : "اختر عدد الأيام"}
              </span>
              {daysDropdownOpen ? (
                <KeyboardArrowUpOutlined style={{ fontSize: "1.2rem" }} />
              ) : (
                <KeyboardArrowDownOutlined style={{ fontSize: "1.2rem" }} />
              )}
            </button>

            {daysDropdownOpen && (
              <>
                <div
                  onClick={() => setDaysDropdownOpen(false)}
                  style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 10,
                  }}
                />
                <div
                  className="shadow-lg rounded-4 bg-white border-0"
                  style={{
                    position: "absolute",
                    top: "calc(100% + 8px)",
                    right: 0,
                    zIndex: 20,
                    padding: "14px",
                    width: "300px",
                  }}
                >
                  <div
                    className="d-grid gap-2"
                    style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
                  >
                    {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => {
                      const isSelected = Number(selectedDays) === day;
                      return (
                        <button
                          key={day}
                          type="button"
                          onClick={() => {
                            setSelectedDays(day);
                            setDaysDropdownOpen(false);
                          }}
                          className="rounded-3 border-0 fw-bold"
                          style={{
                            width: "38px",
                            height: "38px",
                            fontSize: "0.85rem",
                            backgroundColor: isSelected ? "#3EADA3" : "#f5f6f8",
                            color: isSelected ? "#fff" : "#333",
                            transition: "all 0.15s ease",
                          }}
                        >
                          {day}
                        </button>
                      );
                    })}
                  </div>

                  {selectedDays && (
                    <div className="text-center mt-2 pt-2 border-top">
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedDays("");
                          setDaysDropdownOpen(false);
                        }}
                        className="btn btn-link btn-sm text-danger text-decoration-none p-0"
                      >
                        مسح الاختيار
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          </div>
        </div>
        <div className="">
          {loading ? (
            // ===== SKELETON STATE =====
            Array.from({ length: 4 }, (_, i) => renderOrderSkeleton(i))
          ) : orders.length > 0 ? (
            [...orders].reverse().map((order) => (
              <Accordion
                key={order.id}
                expanded={expandedOrder === order.id}
                onChange={() =>
                  setExpandedOrder(
                    expandedOrder === order.id ? null : order.id,
                  )
                }
                sx={{
                  backgroundColor: "#F9F9F9",
                  my: 2,
                  py: 1,
                  border: "none",
                  outline: "none",
                  "&:before": {
                    display: "none",
                  },
                  "&.Mui-expanded": {
                    boxShadow: "none",
                  },
                }}
                className="shadow-sm"
              >
                {/* ===== HEADER ===== */}
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <div className="row w-100 align-items-center">
                    <div className="col-12 d-flex align-items-center">
                      <div className="services-images-url">
                        <img
                          src={order.order_status?.image_url || defaultImage}
                          alt=""
                        />
                      </div>
                      <span className="fw-bold mx-2">{`ORD-#${order.id}`}</span>
                    </div>
                  </div>
                </AccordionSummary>

                {/* ===== DETAILS ===== */}
                <AccordionDetails>
                  <div className="border rounded-4 p-4">
                    <ul style={{ listStyle: "square inside" }}>
                      <li>
                        {`اسم العميل: ${
                          order.user?.name ? order?.user?.name : "....."
                        }`}
                      </li>
                      {/* ===== SERVICES LIST ===== */}
                      <li className="my-1">
                        الخدمات المطلوبة:
                        {order.categories?.map((item) =>
                          item?.subcategories?.map((sub) => (
                            <div
                              key={sub.id}
                              className="d-flex align-items-center gap-2 m-0"
                            >
                              <div className="services-images-url">
                                <img
                                  src={
                                    item.icon_url
                                      ? item.slug === "cover"
                                        ? item.icon_url
                                        : `${newImageUrl}${item.icon_url}`
                                      : defaultImage
                                  }
                                  alt=""
                                />
                              </div>

                              <p className="m-0">{sub.name}</p>
                            </div>
                          )),
                        )}
                      </li>

                      <li className="my-1">{`العنوان: ${order?.address?.area}`}</li>

                      <li className="my-1">{`الوقت المتوقع: ${order?.scheduled_from} - ${order?.scheduled_to}`}</li>
                      {order.discount_total > 0 ? (
                        <>
                          <li>
                            اجمالي قبل الخصم:
                            <span className="fw-bold mx-2">
                              {Number(order?.subtotal).toLocaleString(
                                "en-US",
                              )}{" "}
                              ج.م
                            </span>
                          </li>
                          <li>
                            خصم:
                            <span className="fw-bold text-danger ms-2">
                              {Number(order.discount_total).toLocaleString(
                                "en-US",
                              )}{" "}
                              ج.م
                            </span>
                          </li>
                          <li>
                            الاجمالي:
                            <span className="fw-bold mx-2">
                              {Number(order?.total).toLocaleString("en-US")}{" "}
                              ج.م
                            </span>
                          </li>
                        </>
                      ) : (
                        <li>
                          الاجمالي:
                          <span className="fw-bold mx-2">
                            {Number(order?.total).toLocaleString("en-US")} ج.م
                          </span>
                        </li>
                      )}
                      <li className="my-1 d-flex align-items-center">
                        حالة الطلب : {order?.order_status?.label_ar}
                        <div className="services-images-url mx-2">
                          <img
                            src={
                              order?.order_status?.image_url || defaultImage
                            }
                            alt=""
                          />
                        </div>
                      </li>
                    </ul>

                    {/* ===== BUTTON ===== */}
                    
                    <div
                      className={`d-flex justify-content-center mt-3 `}
                    >
                      <button
                        onClick={() => navigateToCheckItems(order)}
                        className={`btn btn-dark px-5 w-50`}
                        disabled={
                          order.status === "assigned"
                          //  &&
                          // order.status !== "in_progress" &&
                          // order.status !== "awaiting_payment" 
                        }
                      >
                        عرض الخدمات
                      </button>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <>
              <div className="text-center py-5 text-muted">
                لا توجد طلبات مطابقة للبحث
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OrdersExecuting;
